"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var MissMatchException = /** @class */ (function (_super) {
    __extends(MissMatchException, _super);
    function MissMatchException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MissMatchException;
}(Error));
var CELL_TYPES = {
    DATE: 'DATE',
    DISTRIBUTION: 'DISTRIBUTION',
    ANCHOREDSCALE: 'ANCHOREDSCALE'
};
var ColorConfig = /** @class */ (function () {
    function ColorConfig() {
    }
    ColorConfig.RED = '#e8b3ae';
    ColorConfig.GREEN = '#bbe7d3';
    ColorConfig.BLUE = '#91baff';
    return ColorConfig;
}());
exports.ColorConfig = ColorConfig;
var ChangeStatus = /** @class */ (function () {
    function ChangeStatus() {
    }
    ChangeStatus.VALID = 0;
    ChangeStatus.IGNORED = 1;
    ChangeStatus.INVALID = 3;
    return ChangeStatus;
}());
exports.ChangeStatus = ChangeStatus;
var BG_RED = { 'background-color': ColorConfig.RED, 'color': 'black' };
var BG_GREEN = { 'background-color': ColorConfig.GREEN, 'color': 'black' };
var BG_BLUE = { 'background-color': ColorConfig.BLUE, 'color': 'black' };
var BG_NONE = '';
var dateRegex1 = /^([a-zA-Z]+)-(\d+)$/;
var dateRegex2 = /^(\d+)-([a-zA-Z]+)$/;
function isInput(cell) {
    return cell.lookup === 'i' || cell.lookup === 'ti';
}
function isOutput(cell) {
    return cell.lookup === 'o' || cell.lookup === 'to';
}
function isCategory(cell) {
    return cell.lookup === 'c';
}
function getDateString(year, month) {
    var y = typeof year === 'number' ? year : parseInt(year);
    var fullYear = y < 100 ? (y < 50 ? "20" + y : "19" + y) : y;
    return month + " " + fullYear;
}
function formatDate(inputDateString) {
    var dateString = inputDateString.trim();
    var match1 = dateRegex1.exec(dateString);
    if (match1) {
        return getDateString(match1[2], match1[1]);
    }
    var match2 = dateRegex2.exec(dateString);
    if (match2) {
        return getDateString(match2[2], match2[1]);
    }
    var date = new Date(dateString);
    return getDateString(date.getMonth(), date.getFullYear());
}
function verfiyColHeaers(newHeaders, headerMap) {
    if (newHeaders.length != headerMap.length) {
        throw new MissMatchException("Column header count mismatched!");
    }
    var count = newHeaders.length;
    for (var i = 0; i < count; i++) {
        if (newHeaders[i].trim() !== headerMap[i].display.trim()) {
            throw new MissMatchException("Column header (" + headerMap[i].display + ") mismatched at column " + i + "!");
        }
    }
}
function verifyRowHeaders(newRows, newData) {
    if (newRows.length !== newData.length - 1) {
        throw new MissMatchException('Row count mismatched');
    }
    var colIndexOfRowHeader = newData[0].indexOf('Projects');
    if (colIndexOfRowHeader < 0) {
        throw new MissMatchException('Cannot find Projects column.');
    }
    for (var i = 1; i < newData.length; i++) {
        var rowHeader = newRows[i - 1].name;
        if (rowHeader.trim() !== newData[i][colIndexOfRowHeader].trim()) {
            throw new MissMatchException("Row header mismatched. Please check " + i + " row (" + rowHeader + ") !");
        }
    }
}
function verifyCategoryEditPermission(category, userPrivilege, allowContributorEdit, cell) {
    if (userPrivilege === 3)
        return true;
    if (userPrivilege === 2) {
        if (!allowContributorEdit) {
            cell.message = "Contributor is not allowed to edit category in this Universal Table.\n";
            return false;
        }
        if (!category.ContributorEditing) {
            cell.message = "Contributor has no permission to edit " + category.CategoryName + ".\n";
            return false;
        }
        return true;
    }
    return false;
}
function verifyCategoryEntries(category, entryStr, cell) {
    var inputEntries = entryStr.split(',');
    var categoryName = category.CategoryName;
    var validEntries = category.CategoryEntries;
    if (inputEntries.length > 1 && category.IsMultiSelect !== 'true') {
        // Problem: cannot multi select
        cell.message = categoryName + " is single select category.\n";
        return false;
    }
    var result = true;
    inputEntries.forEach(function (entry) {
        if (entry.trim() === '') {
            return;
        }
        if (validEntries.filter(function (i) { return entry.replace(/\s/g, '') === i; }).length === 0) {
            // Problem: no such entry
            cell.message = entry + " does not exist in category: " + categoryName + ".\n";
            result = false;
        }
    });
    return result;
}
function verifyAndSetBackgroundColor(cell, oldValue, isReadonly, rowName, columnName, dropdownList, category, userPrivilege, allowContributorEdit, newRows, baseYear) {
    if (category === void 0) { category = {}; }
    if (typeof cell === 'undefined') {
        return ChangeStatus.IGNORED;
    }
    cell.message = '';
    if (isReadonly) {
        cell.style = BG_RED;
        cell.message += rowName + " is read-only.\n";
        return ChangeStatus.INVALID;
    }
    var cv = typeof cell.value === 'string' ? cell.value.trim() : cell.value;
    var ov = typeof oldValue === 'string' ? oldValue.trim() : oldValue;
    if (isCategory(cell)) {
        var cs = new Set(cv.replace(/\s+/g, '').split(','));
        cv = Array.from(cs).sort().join(',');
        if (cv.length != cs.size) {
            var tempArr_1 = [];
            cs.forEach(function (key, value, set) {
                tempArr_1.push(value);
            });
            cv = tempArr_1.sort().join(',');
        }
        ov = ov.replace(/\s+/g, '').split(',').sort().join(',');
        if ((!cv && !ov) || (cv == ov)) {
            cell.style = BG_NONE;
            return ChangeStatus.IGNORED;
        }
        if (!verifyCategoryEditPermission(category, userPrivilege, allowContributorEdit, cell) ||
            !verifyCategoryEntries(category, cv, cell)) {
            cell.style = BG_RED;
            return ChangeStatus.INVALID;
        }
    }
    // Use == because value can be number or string.
    if (isOutput(cell) && cv != ov) {
        cell.style = BG_RED;
        cell.message = 'Output cannot be changed.';
        return ChangeStatus.IGNORED;
    }
    if ((!cv && !ov) || (cv == ov)) {
        cell.style = BG_NONE;
        return ChangeStatus.IGNORED;
    }
    if (isInput(cell)) {
        if (isReadonly || cell.inherited) {
            cell.style = BG_RED;
            cell.message += columnName + " is read-only.\n";
            return ChangeStatus.INVALID;
        }
        if (cell.notAvailable) {
            cell.style = BG_RED;
            cell.message += columnName + " is not available in the template.\n";
            return ChangeStatus.INVALID;
        }
        if (dropdownList && dropdownList.indexOf(cv) == -1) {
            cell.style = BG_RED;
            cell.message += cell.value + " is not in the list.\n";
            return ChangeStatus.INVALID;
        }
        if (cell.key == 'CUnGMFTable') {
            var columnNameSplit = columnName.split('|');
            var year = columnNameSplit[2];
            for (var i = 0; i < newRows.length; i++) {
                if (newRows[i]['name'] == rowName) {
                    baseYear = 'baseYear' in newRows[i] ? newRows[i]['baseYear'] : '';
                    if (year == baseYear) {
                        cell.style = BG_RED;
                        cell.message += cell.key + " with base year " + year + " cannot be edited in universal table.\n";
                        return ChangeStatus.INVALID;
                    }
                }
            }
        }
        if ((typeof cell.min !== 'undefined' && parseFloat(cv) < cell.min) ||
            (typeof cell.max !== 'undefined' && parseFloat(cv) > cell.max)) {
            cell.style = BG_RED;
            cell.message += columnName + " value out of range.";
            return ChangeStatus.INVALID;
        }
    }
    cell.style = BG_BLUE;
    return ChangeStatus.VALID;
}
function addToChangeList(changes, nodeId, nodeName, _a, header, baseYear) {
    var lookup = _a.lookup, key = _a.key, type = _a.type, value = _a.value;
    if (!changes[nodeId]) {
        changes[nodeId] = {
            nodeName: nodeName,
            inputs: {},
            categories: {}
        };
    }
    if (lookup === 'ti') {
        if (!(key == 'CUnGMFTable' && Number(header.colHeader) == Number(baseYear))) {
            var ti = changes[nodeId].inputs;
            if (!ti[key]) {
                ti[key] = [];
            }
            ti[key].push({
                rowHeader: header.rowHeader,
                colHeader: header.colHeader,
                value: value
            });
        }
    }
    else if (lookup === 'c') {
        changes[nodeId].categories[key] = value;
    }
    else {
        if (type === CELL_TYPES.DISTRIBUTION) {
            if (!changes[nodeId].inputs[key]) {
                changes[nodeId].inputs[key] = {};
            }
            changes[nodeId].inputs[key][header.disIndex] = value;
        }
        else {
            changes[nodeId].inputs[key] = value;
        }
    }
}
function generateNewTable(headerMap, originalRows, pastedData, categoryConfig, userPrivilege, allowContributorEdit) {
    var lineSeperator = pastedData.indexOf('\n') >= 0 ? '\n' : '\r';
    var excelRows = pastedData.split(lineSeperator);
    var newData = excelRows.filter(function (row) { return row && row.trim(); }).map(function (row) { return row.split('\t'); });
    var changes = {};
    var invalidChanges = [];
    var changedDropdownCategories = [];
    if (userPrivilege < 2) {
        throw new MissMatchException('Insufficient Privilege!\n Observer has no edit access to Universal Table');
    }
    verfiyColHeaers(newData[0], headerMap);
    var newRows = JSON.parse(JSON.stringify(originalRows));
    verifyRowHeaders(newRows, newData);
    for (var i = 1; i < newData.length; i++) {
        var newDataRow = newData[i];
        var tableRow = newRows[i - 1];
        var isReadonly = tableRow.readonly;
        var rowName = tableRow.name;
        var baseYear = 'baseYear' in tableRow ? tableRow['baseYear'] : '';
        var nodeChangedDropdowns = {};
        var _loop_1 = function (j) {
            var _a = headerMap[j], key = _a.key, valKey = _a.valKey, isRowHeader = _a.isRowHeader, display = _a.display, lookup = _a.lookup;
            if (isRowHeader) {
                if (newDataRow[j].trim() !== tableRow[key].trim()) {
                    throw new MissMatchException("Row header (" + tableRow[key] + ") mismatched at row " + i + "!");
                }
            }
            else {
                var cell = tableRow[key];
                var oldValue = cell.value;
                cell.value = cell.type === CELL_TYPES.DATE ? formatDate(newDataRow[j]) : newDataRow[j];
                var cate = {};
                if (lookup === 'Categories') {
                    cate = categoryConfig.find(function (item) { return item.CategoryName === valKey; });
                }
                var t = headerMap[j]['type'];
                var dropdownList = (t === "DROPDOWN" || t === 'DATABASE_DROPDOWN') ? headerMap[j]['list'] : undefined;
                var cs = verifyAndSetBackgroundColor(cell, oldValue, isReadonly, rowName, display, dropdownList, cate, userPrivilege, allowContributorEdit, newRows, baseYear);
                if (cs === ChangeStatus.VALID) {
                    addToChangeList(changes, tableRow.id, tableRow.name, cell, headerMap[j], baseYear);
                    if (cell.lookup == 'i' && ["DROPDOWN", "DATABASE_DROPDOWN"].indexOf(cell.type) > -1) {
                        nodeChangedDropdowns[cell.key] = cell.value;
                    }
                }
                else if (cs === ChangeStatus.INVALID) {
                    invalidChanges.push({
                        nodeName: tableRow.name,
                        message: cell.message
                    });
                }
            }
        };
        for (var j = 0; j < newDataRow.length; j++) {
            _loop_1(j);
        }
        if (Object.keys(nodeChangedDropdowns).length > 0) {
            changedDropdownCategories.push({
                nodeID: tableRow.id,
                categories: nodeChangedDropdowns
            });
        }
    }
    return { newRows: newRows, changes: changes, invalidChanges: invalidChanges, changedDropdownCategories: changedDropdownCategories };
}
exports.generateNewTable = generateNewTable;
//# sourceMappingURL=universal-table.paste.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/universal-table2/universal-table.paste.js